module.exports = __webpack_public_path__ + "img/apple.8de6eab5.jpg";